import React from 'react'

function SvgPaperClip(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
        d="M17.626 9.083l-7.513 7.513a4.375 4.375 0 01-6.187-6.187l7.513-7.513a2.917 2.917 0 014.125 4.125l-7.219 7.218a1.458 1.458 0 11-2.062-2.062l6.334-6.335"
      ></path>
    </svg>
  )
}

export default SvgPaperClip
